const angular = require('angular');
import HighlightComponent  from '../infra/highlight.directive';
import {HighlightService}  from '../infra/highlight.service';
export default angular.module('primo-explore.components',[])
    .component(HighlightComponent.name, HighlightComponent.config)
    .service('HighlightService', HighlightService);


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExploreComponents.modules.ts